import { render } from "./DiagramBackupList.vue?vue&type=template&id=5a493587"
import script from "./DiagramBackupList.vue?vue&type=script&lang=js"
export * from "./DiagramBackupList.vue?vue&type=script&lang=js"

import "./DiagramBackupList.vue?vue&type=style&index=0&id=5a493587&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__